import colorMod from 'color';

export default ({ typography, fontSize, color }) => ({
  dashboard: {
    backgroundColor: color.uiBackground,
    color: color.bodyText,
    fontFamily: typography.bodyText,
    margin: 'auto',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: '30px',
    paddingBottom: '14vh',
  },
  dashboardContainer: {
    marginLeft: 36,
    marginRight: 36,
  },
  dashboardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  loader: {
    width: '100%',
    display: 'flex',
    height: 500,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chartPanel: {
    boxShadow: '0px 2px 8px #00000033',
    backgroundColor: '#ffffff',
    borderRadius: 5,
    height: 60,
    marginTop: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media print': {
      display: 'none',
    },
  },
  dashboardLabel: {
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.pageTitle,
  },
  exportBtnContainer: {
    '@media print': {
      display: 'none',
    },
  },
  exportBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontFamily: `${typography.bodyText} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontWeight: 'normal !important',
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  labelForPrint: {
    marginTop: 40,
    '@media print': {
      display: 'block',
    },
  },
  placeholderText: {
    fontSize: fontSize.smallText,
  },
  report: {
  },
  addPanelBtn: {
    backgroundColor: `${color.primaryButtonText} !important`,
    border: `1px solid ${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonBackground} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontWeight: 'normal',
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:focus': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      boxShadow: 'none',
      outline: 'none',
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
  },
});
